module.exports = __webpack_public_path__ + "files/07d570072c77062cd0e79d14e6b4bf10.png";